import {State} from '../types'
import {getEvent} from './event'

export const getCalendarLinks = (state: State) => state.calendarLinks || getEvent(state).calendarLinks
